import {InputAdornment} from '@mui/material';
import TextField from '@jobseeker/lotus/elements/Input';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {Image} from '@jobseeker/lotus/components/Image';
import {Search} from '@jobseeker/lotus/assets/icons';
import {BaseSyntheticEvent} from 'react';

export type PersonalizeSearchType = {
  searchValue: string;
  width?: string;
  onFilterChange?: (event: BaseSyntheticEvent) => void;
};
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const PersonalizeSearch = ({
  searchValue,
  width,
  onFilterChange,
}: PersonalizeSearchType) => {
  return (
    <TextField
      placeholder={isAppIimjobs ? 'Search Tags' : 'Search Category, Keyword...'}
      variant={VersionVariants.VERSION_ONE}
      aria-autocomplete="list"
      aria-expanded="true"
      autoComplete="off"
      spellCheck="false"
      aria-invalid="false"
      name="query"
      value={searchValue}
      onChange={onFilterChange}
      // helperText={'Few special character and spaces are not allowed'}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Image
              src={Search}
              alt={'Search'}
              width={18}
              height={18}
              style={{
                filter: 'brightness(3)',
              }}
              objectFit="cover"
            />
          </InputAdornment>
        ),
      }}
      sx={{
        zIndex: 3,
        fontSize: 14,
        width: {xs: width, md: 300},
        height: '48px',
        '.MuiInputBase-root': {
          fontSize: 14,
          width: '100%',
          height: '100%',
          borderTopRightRadius: '28px',
          borderBottomRightRadius: '28px',
          border: 'none',
          '&:focus': {
            outline: 'none',
          },
        },
        '& .MuiOutlinedInput-root': {
          border: '1px solid #e6e6e6',
          borderRadius: '28px',
          backgroundColor: '#fff',
        },
        '& fieldset': {
          border: 'none',
        },
        '&:hover fieldset': {
          border: 'none',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'text.primary',
          borderWidth: '1px',
        },
        mb: {xxs: 0.5, md: 0},
      }}
    />
  );
};

export default PersonalizeSearch;
